import { OrganizationFormDetailPage } from "./-components/organization-form-detail-page";
import { getOrganizationFormsGetFormQueryOptions } from "@/orval/organization-forms";
import { ensureRouteQueryData } from "@/lib/route-loader";
import { numericIdParamSchema } from "@/lib/route-params";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

const searchSchema = z.object({ tab: z.enum(["layout", "submissions"]).optional() });

export const Route = createFileRoute("/_app/organizations/$organizationId/admin/forms_/$formId")({
  params: {
    parse: (params) => z.object({ organizationId: numericIdParamSchema, formId: numericIdParamSchema }).parse(params),
  },
  validateSearch: searchSchema,
  loader: ({ params, ...loaderContext }) =>
    ensureRouteQueryData(loaderContext, getOrganizationFormsGetFormQueryOptions(params.organizationId, params.formId)),
  component: RouteComponent,
});

function RouteComponent() {
  const { organizationId, formId } = Route.useParams();
  const { tab = "layout" } = Route.useSearch();
  return (
    <OrganizationFormDetailPage
      key={`${organizationId}:${formId}`}
      organizationId={organizationId}
      formId={formId}
      tab={tab}
    />
  );
}
